import { color, defineComponent, ISoilAnalysisColor, SoilUnit } from "../../omnia"
import { SoilMapContext } from "./context"

/// <reference path="context.ts" />

export class MapViewerCtrl {

    static create(): ng.IDirective {
        return defineComponent(MapViewerCtrl, "app/soil/dashboard/map/viewer.html", {
            context: "="
        });
    }

    public context: SoilMapContext;

    get key() {
        return this.context?.colorKey
    }

    getKeyCellStyle(c: ISoilAnalysisColor) {

        return {
            'background-color': color.colorToCss(c.Colour)
        }

    }

    getKeyItemValue(c: ISoilAnalysisColor) {

        const view = this.context.view;
        const index = view.currentUnit === SoilUnit.Index

        const value = index
            ? c.Index
            : c.Label !== undefined
                ? c.Label
                : c.Value

        return value;
    }

}
